import React, { useState, useCallback } from 'react';
import TransactionsIcon from "../components/icons/transactions";
import { useTheme } from '@mui/joy';

const UIContext = React.createContext();

export const UIContextProvider = (props) => {
    const theme = useTheme();

    // Menú completo para admin
    const getAdminMenu = () => [
        { 
            icon: <TransactionsIcon theme={theme} />, 
            name: 'Operaciones', 
            state: true, 
            route: "/tx" 
        },
        { 
            icon: <TransactionsIcon theme={theme} />, 
            name: 'Transacciones', 
            state: false, 
            route: "/transactions" 
        },
        { 
            icon: <TransactionsIcon theme={theme} />, 
            name: 'Administrador', 
            state: false, 
            route: "/admin" 
        },
        { 
            icon: <TransactionsIcon theme={theme} />, 
            name: 'Retiros', 
            state: false, 
            route: "/withdrawals" 
        },
    ];

    // Menú limitado para operador
    const getOperatorMenu = () => [
        { 
            icon: <TransactionsIcon theme={theme} />, 
            name: 'Operaciones', 
            state: true, 
            route: "/tx" 
        },
        { 
            icon: <TransactionsIcon theme={theme} />, 
            name: 'Transacciones', 
            state: false, 
            route: "/transactions" 
        },
    ];

    // Inicializar con menú de operador por defecto para evitar undefined
    const [menu, setMenu] = useState(getOperatorMenu());

    // Función para establecer el menú según el tipo de usuario
    const setMenuByUserType = useCallback((userType) => {
        if (userType === 'admin') {
            setMenu(getAdminMenu());
        } else if (userType === 'operator') {
            setMenu(getOperatorMenu());
        } else {
            setMenu(getOperatorMenu());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [theme]);

    // Referidos [#33]: only shown to operators/admins who actually have referidos.
    // Inserted after "Retiros" when present, otherwise appended. Idempotent.
    const addReferidosToMenu = useCallback(() => {
        setMenu(prev => {
            if (prev.some(item => item.route === '/referidos')) return prev;
            const referidosItem = {
                icon: <TransactionsIcon theme={theme} />,
                name: 'Referidos',
                state: false,
                route: "/referidos"
            };
            const retirosIdx = prev.findIndex(item => item.route === '/withdrawals');
            if (retirosIdx === -1) return [...prev, referidosItem];
            const next = [...prev];
            next.splice(retirosIdx + 1, 0, referidosItem);
            return next;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [theme]);

    const setActiveMenuItem = (index) => {
        setMenu(prev => prev.map((item, i) => ({
            ...item,
            state: index === i
        })));
    };

    const resetMenuState = () => {
        setMenu(prev => prev.map((item, i) => ({
            ...item,
            state: i === 0
        })));
    };

    const clearMenu = () => {
        setMenu(getOperatorMenu());
    };

    return (
        <UIContext.Provider
            value={{
                menu,
                setActiveMenuItem,
                resetMenuState,
                setMenuByUserType,
                addReferidosToMenu,
                clearMenu
            }}
        >
            {props.children}
        </UIContext.Provider>
    );
};

export default UIContext;